export default __webpack_public_path__ + "static/b2-9b201881e73b25629140c9bbbc305f5a.png";